import { createSlice } from '@reduxjs/toolkit';
import { ServicesSchema } from '../types/servicesTypes';

const initialState: ServicesSchema = {
    products: [],
    specialProducts: [],
    productsInfo: [],
};

export const ServicesSlice = createSlice({
    name: 'Services',
    initialState,
    reducers: {
        setProducts: (state, { payload }) => {
            state.products = payload;
        },
        setSpecialProducts: (state, { payload }) => {
            state.specialProducts = payload;
        },
        setProductsInfo: (state, { payload }) => {
            console.log(payload, 'setProductsInfo')
            state.productsInfo = payload;
        },
        changeStatusInfo: (state, { payload }) => {
            //@ts-ignore
            state.productsInfo[payload.key].status = payload.status;
        },
    },
});

export const { actions: servicesActions } = ServicesSlice;
export const { reducer: servicesReducer } = ServicesSlice;
